import { filterClasses } from "@swivl-mono/helpers";
import { InputSize, SearchInput } from "@swivl-mono/ui";

import { SMSCampaignButton } from "../../Components/SMSCampaignButton/SMSCampaignButton";
import { ConversationUserListTabsStateType } from "../../ConversationsView";

interface EscalationsHeaderProps {
  conversationSearchTerm: string;
  setConversationsSearchTerm: (searchTerm: string) => void;
  tabState: ConversationUserListTabsStateType;
  setTab: (state: ConversationUserListTabsStateType, fromClick?: boolean) => void;
}

export function ConversationsUserListColumnHeader({ setConversationsSearchTerm, conversationSearchTerm, tabState, setTab }: EscalationsHeaderProps) {
  const isOpen = tabState !== ConversationUserListTabsStateType.Closed;

  return (
    <div className="flex h-12 items-center justify-between border-b border-gray-200 bg-white px-4">
      <div className="flex h-full w-full items-center justify-between gap-2">
        {/* escalation status tabs */}
        <div className="relative my-4 flex h-full items-center gap-8 px-4 text-sm font-semibold">
          <button
            className="cursor-pointer transition-colors duration-100 hover:text-red-500"
            onClick={() => setTab(ConversationUserListTabsStateType.Open, true)}
          >
            Open
          </button>
          <button
            className="cursor-pointer transition-colors duration-100 hover:text-red-500"
            onClick={() => setTab(ConversationUserListTabsStateType.Closed, true)}
          >
            Closed
          </button>
          <div
            className={filterClasses(
              "absolute bottom-0 h-[3px] w-16 bg-orange-500 transition-transform duration-300 ease-in-out",
              isOpen ? "-translate-x-3.5" : "translate-x-[49.5px]"
            )}
          />
        </div>

        {/* search input */}
        <SearchInput
          isExpandable
          placeholder="Search..."
          value={conversationSearchTerm}
          onChange={(e) => setConversationsSearchTerm(e.target.value)}
          onClear={() => setConversationsSearchTerm("")}
        />
      </div>
    </div>
  );
}
